import script from "./CardPasswordSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPasswordSecurity.vue?vue&type=script&setup=true&lang=js"

import "./CardPasswordSecurity.vue?vue&type=style&index=0&id=0318bf3b&lang=scss"

const __exports__ = script;

export default __exports__